import React from 'react';
import { Card, Row, Col, Select, Button, DatePicker, Space, Empty, Statistic, Progress } from 'antd';
import { Line, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import dayjs from 'dayjs';
import axios from 'axios';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, ArcElement);

export default function Analytics() {
  const [selectedDevice, setSelectedDevice] = React.useState('');
  const [devices, setDevices] = React.useState([]);
  const [data, setData] = React.useState(null);
  const [dateRange, setDateRange] = React.useState([dayjs().subtract(7, 'days'), dayjs()]);

  const authHeader = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  React.useEffect(() => {
    loadDevices();
  }, []);

  React.useEffect(() => {
    if (selectedDevice) loadAnalytics();
  }, [selectedDevice, dateRange]);

  const loadDevices = async () => {
    try {
      const response = await axios.get('/api/devices', { headers: authHeader() });
      const list = response.data.devices || [];
      setDevices(list);
      if (list.length && !selectedDevice) setSelectedDevice(list[0].device_id);
    } catch (error) {
      console.error('Error loading devices:', error);
    }
  };

  const loadAnalytics = async () => {
    try {
      const response = await axios.get(`/api/data/${selectedDevice}/stats?period=24h`, { headers: authHeader() });
      setData(response.data);
    } catch (error) {
      console.error('Error loading analytics:', error);
    }
  };

  const chartData = {
    labels: ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00'],
    datasets: [
      {
        label: 'Temperatura',
        data: [22, 21.5, 23, 24.5, 25.2, 23.8],
        borderColor: 'rgb(255, 159, 64)',
        backgroundColor: 'rgba(255, 159, 64, 0.1)',
      },
      {
        label: 'Humedad',
        data: [65, 62, 58, 55, 60, 63],
        borderColor: 'rgb(54, 162, 235)',
        backgroundColor: 'rgba(54, 162, 235, 0.1)',
      },
    ],
  };

  return (
    <div>
      <h1 style={{ marginBottom: '20px' }}>📈 Análitica</h1>

      <Card style={{ marginBottom: '20px' }}>
        <Space>
          <Select
            value={selectedDevice}
            onChange={setSelectedDevice}
            style={{ width: 200 }}
          >
            {devices.map((d) => (
              <Select.Option key={d.device_id} value={d.device_id}>{d.name}</Select.Option>
            ))}
          </Select>
          <DatePicker.RangePicker
            value={dateRange}
            onChange={setDateRange}
          />
          <Button type="primary">Filtrar</Button>
        </Space>
      </Card>

      {data ? (
        <>
          <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
            {Object.entries(data.sensors || {}).map(([name, stats]) => (
              <Col key={name} xs={24} sm={12} lg={8}>
                <Card>
                  <div style={{ textAlign: 'center' }}>
                    <h3>{name.toUpperCase()}</h3>
                    <Statistic
                      value={stats.current}
                      suffix={stats.unit}
                      valueStyle={{ fontSize: '32px', fontWeight: 'bold' }}
                    />
                    <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                      <div>Min: {stats.min} {stats.unit}</div>
                      <div>Max: {stats.max} {stats.unit}</div>
                      <div>Promedio: {stats.avg} {stats.unit}</div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <Card title="Gráfica de Sensores (últimas 24h)">
                <Line data={chartData} options={{ responsive: true }} height={300} />
              </Card>
            </Col>
          </Row>
        </>
      ) : <Empty description="Sin datos para este dispositivo" />}
    </div>
  );
}
